var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.pageNo < _vm.pages)?_c('div',{staticClass:"page hand-style no-select",on:{"click":_vm.handlePage}},[_vm._v(" 加载更多 ")]):_c('div',{staticClass:"tips"},[_c('div',{staticClass:"divider"}),_c('div',{staticClass:"content"},[_vm._v("没有更多内容了")]),_c('div',{staticClass:"divider"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }